import SlideOver from 'src/components/ui/SlideOver/SlideOver'
import { CloseButtonIcon } from 'src/components/Icons/CloseButtonIcon'
import { useModal } from 'src/sdk/ui/modal/Provider'
import type { ComponentType } from 'react'

import LearnMoreBannerSectionData from '../LearnMoreBannerSectionData/LearnMoreBannerSectionData'
import LearnMoreSectionContentText from '../LearnMoreSectionContentText/LearnMoreSectionContentText'
import LearnMoreSectionTablePrices from '../LearnMoreSectionTablePrices/LearnMoreSectionTablePrices'

interface ModalInsuranceProps {
  isOpen: boolean
  onDismiss: () => void
  cmsData: any
}

type Section = {
  name: string
  data: any
  [key: string]: any
}

const COMPONENTS: Record<string, ComponentType<any>> = {
  '[Seguro Bike] Banner Seguro B-ON': LearnMoreBannerSectionData,
  '[Seguro Bike] Seção de texto': LearnMoreSectionContentText,
  '[Seguro Bike] Tabela de Preços': LearnMoreSectionTablePrices,
}

const ModalLearnMoreBikeInsurance = ({
  isOpen,
  onDismiss,
  cmsData,
}: ModalInsuranceProps) => {
  const sections: Section[] | undefined = cmsData?.sections
  const { onModalClose } = useModal()

  const handleClose = () => {
    document.documentElement.classList.remove('no-scroll')
    onModalClose()
    // Pequeno delay para garantir que a animação e remoção da classe aconteçam
    setTimeout(() => {
      onDismiss()
    }, 50)
  }

  return (
    <SlideOver
      isOpen={isOpen}
      onDismiss={onDismiss}
      direction="rightSide"
      size="partial"
      className="w-full sm:w-[390px]"
    >
      <div className="flex flex-col h-screen">
        <header className="flex justify-end items-center p-4">
          <button className="cursor-pointer" onClick={handleClose}>
            <CloseButtonIcon size={24} />
          </button>
        </header>
        <div className="flex-1 overflow-auto">
          {sections?.map(({ data, name }: Section, index: number) => {
            const Component = COMPONENTS[name]

            if (!Component) {
              console.info(
                `Could not find component for block ${name}. Add a new component for this block or remove it from the CMS`
              )

              return null
            }

            return (
              <Component
                key={`cms-section-${name}-${index}`}
                {...data}
                parentComponent="store-locator"
                section={name}
                type="store-locator"
              />
            )
          })}
        </div>
        <footer className="flex justify-center p-4">
          <button
            className="h-12 border border-[#B3BAC3] rounded-full w-[350px] text-black text-base text-center font-semibold"
            onClick={handleClose}
          >
            Entendi
          </button>
        </footer>
      </div>
    </SlideOver>
  )
}

export default ModalLearnMoreBikeInsurance
